"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPricerProduct = exports.PricerProductProperty = void 0;
/**
 * Pricer plaza prodouct properties that can be used in template editor
 */
var PricerProductProperty;
(function (PricerProductProperty) {
    PricerProductProperty["itemId"] = "itemId";
    PricerProductProperty["itemName"] = "itemName";
    PricerProductProperty["price"] = "price";
    PricerProductProperty["itemGroup"] = "itemGroup";
    PricerProductProperty["department"] = "department";
    PricerProductProperty["presentation"] = "presentation";
    PricerProductProperty["lastUpdated"] = "lastUpdated";
    PricerProductProperty["validFrom"] = "validFrom";
    PricerProductProperty["properties.SUPPLIER"] = "properties.SUPPLIER";
    PricerProductProperty["properties.brandId"] = "properties.brandId";
    PricerProductProperty["properties.bulletPointsFi0"] = "properties.bulletPointsFi0";
    PricerProductProperty["properties.bulletPointsFi1"] = "properties.bulletPointsFi1";
    PricerProductProperty["properties.bulletPointsFi2"] = "properties.bulletPointsFi2";
    PricerProductProperty["properties.bulletPointsFi3"] = "properties.bulletPointsFi3";
    PricerProductProperty["properties.bulletPointsFi4"] = "properties.bulletPointsFi4";
    PricerProductProperty["properties.descriptionShortFi"] = "properties.descriptionShortFi";
    PricerProductProperty["properties.pid"] = "properties.pid";
    PricerProductProperty["properties.priceCurrent"] = "properties.priceCurrent";
    PricerProductProperty["properties.priceCurrentFormatted"] = "properties.priceCurrentFormatted";
    PricerProductProperty["properties.priceCurrentTaxless"] = "properties.priceCurrentTaxless";
    PricerProductProperty["properties.priceDeposit"] = "properties.priceDeposit";
    PricerProductProperty["properties.priceDiscountAmount"] = "properties.priceDiscountAmount";
    PricerProductProperty["properties.priceDiscountBeginAt"] = "properties.priceDiscountBeginAt";
    PricerProductProperty["properties.priceDiscountEndAt"] = "properties.priceDiscountEndAt";
    PricerProductProperty["properties.priceDiscountId"] = "properties.priceDiscountId";
    PricerProductProperty["properties.priceDiscountName"] = "properties.priceDiscountName";
    PricerProductProperty["properties.priceDiscountPercentage"] = "properties.priceDiscountPercentage";
    PricerProductProperty["properties.priceDiscountType"] = "properties.priceDiscountType";
    PricerProductProperty["properties.priceOriginal"] = "properties.priceOriginal";
    PricerProductProperty["properties.priceOriginalFormatted"] = "properties.priceOriginalFormatted";
    PricerProductProperty["properties.priceOriginalTaxless"] = "properties.priceOriginalTaxless";
    PricerProductProperty["properties.priceTaxRate"] = "properties.priceTaxRate";
    PricerProductProperty["properties.priceUnitSymbol"] = "properties.priceUnitSymbol";
    PricerProductProperty["properties.priceUnitTaxless"] = "properties.priceUnitTaxless";
    PricerProductProperty["properties.priceUnitValue"] = "properties.priceUnitValue";
    PricerProductProperty["properties.productId"] = "properties.productId";
    PricerProductProperty["properties.ratingAverageOverallRating"] = "properties.ratingAverageOverallRating";
    PricerProductProperty["properties.ratingOther1"] = "properties.ratingOther1";
    PricerProductProperty["properties.ratingOther2"] = "properties.ratingOther2";
    PricerProductProperty["properties.ratingOther3"] = "properties.ratingOther3";
    PricerProductProperty["properties.ratingOther4"] = "properties.ratingOther4";
    PricerProductProperty["properties.ratingOther5"] = "properties.ratingOther5";
    PricerProductProperty["properties.ratingRecommendedCount"] = "properties.ratingRecommendedCount";
    PricerProductProperty["properties.ratingReviewCount"] = "properties.ratingReviewCount";
    PricerProductProperty["properties.brandName"] = "properties.brandName";
})(PricerProductProperty = exports.PricerProductProperty || (exports.PricerProductProperty = {}));
/** is pricer plaza product */
exports.isPricerProduct = (product) => product === null || product === void 0 ? void 0 : product.itemId;
//# sourceMappingURL=productsPricer.js.map